var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasNodeHidden ? true : _vm.imgUrl)?_c('img',{ref:"currentImg",staticClass:"wownow-image",attrs:{"src":_vm.imgUrl},on:{"click":_vm.imgClick,"load":_vm.onloadImage,"error":_vm.onError}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }